import "./ManageBrandPage.scss";
import "../../../static/fonts/fonts.css";
import Breadcrumbs from "../Breadcrumbs";
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button } from "../misc/Button";
import {
  BrandBackgroundImageDto,
  BrandLogoDto,
  BrandColorDto,
  BrandFontDto,
  BrandProFontDto,
} from "../../../generated/dashboard-client";
import { useRecoilState } from "recoil";
import { memberState } from "../../../state/atoms";
import { useParams } from "react-router";
import { success } from "../../../service/MessageService";
import BrandsApi from "../../../api/BrandsApi";
import {
  ImageUploaderTypeEnum,
  Uploader,
  UploadTypeEnum,
} from "../misc/Uploader";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { getImagePath } from "../../../util/utils";
import { Dropdown, Skeleton } from "antd";
import ColorPicker from "../misc/color-picker/ColorPicker";
import { Select } from "antd";
import { Option } from "antd/lib/mentions";
import { GoogleFonts } from "../../../util/fonts";
import FontSelect from "../misc/FontSelect";
import WebFont from "webfontloader";
import { AccountRoutesEnum } from "../../../util/AccountRoutes";
import { env } from "../../../env/env";

export function ManageBrandPage() {
  const [member] = useRecoilState(memberState);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  let { id } = useParams<{ id: string }>();
  const [name, setName] = useState("");
  const [fontHeader, setFontHeader] = useState({} as BrandFontDto);
  const [fontSubheader, setFontSubheader] = useState({} as BrandFontDto);
  const [fontBodyText, setFontBodyText] = useState({} as BrandFontDto);
  const [logos, setLogos] = useState([] as BrandLogoDto[]);
  const [colors, setColors] = useState([] as BrandColorDto[]);
  const [backgroundImages, setBackgroundImages] = useState(
    [] as BrandBackgroundImageDto[]
  );
  const [proFonts, setProFonts] = useState([] as BrandProFontDto[]);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (!id) return;
    setLoading(true);

    BrandsApi.getBrand(id)
      .then((resp) => {
        const brand = resp.data;
        setName(brand.name || "");
        setLogos(brand.logos || []);
        setColors(brand.colors || []);
        setBackgroundImages(brand.backgroundImages || []);
        setFontHeader(brand.fontHeader || {});
        setFontSubheader(brand.fontSubheader || {});
        setFontBodyText(brand.fontBodyText || {});
        setProFonts(brand.proFonts || []);
        setEditing(!(brand.draft || false));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });

    WebFont.load({
      google: {
        families: GoogleFonts,
      },
    });
  }, [id]);

  function getBrand(): any {
    return {
      id,
      name,
      fontHeader,
      fontSubheader,
      fontBodyText,
      colors: colors,
      proFonts: proFonts,
      memberId: member.id,
    };
  }

  function save() {
    setSaving(true);
    update();
  }

  function update() {
    BrandsApi.updateBrand(getBrand())
      .then(() => {
        setSaving(false);
        success("Brand updated!");
        navigate(env.dashboardPath + "/account/brands");
      })
      .catch(() => {
        setSaving(false);
      });
  }

  function disableCreateButton() {
    return false;
  }

  function addColor(hex: string) {
    setColors([{ colorCode: hex }, ...colors]);
  }

  function setFontHeaderCallback(font: BrandFontDto) {
    setFontHeader(font);
  }

  function setFontSubheaderCallback(font: BrandFontDto) {
    setFontSubheader(font);
  }

  function setFontBodyTextCallback(font: BrandFontDto) {
    setFontBodyText(font);
  }

  function addProFont(name: string) {
    setProFonts([...proFonts, { name }]);
  }

  function removeProFont(name: string) {
    setProFonts(proFonts.filter((p) => p.name !== name));
  }

  function onLogoUploadSuccess(logo: BrandLogoDto) {
    setLogos([logo, ...logos]);
  }

  function onBackgroundImageUploadSuccess(
    backgroundImage: BrandBackgroundImageDto
  ) {
    setBackgroundImages([backgroundImage, ...backgroundImages]);
  }

  return (
    <div className={"content new-brand-page"}>
      <Breadcrumbs>
        <li>
          <NavLink to={AccountRoutesEnum.Brands}>Brands</NavLink>
        </li>
        <li>{editing ? "Edit Brand" : "New Brand"}</li>
      </Breadcrumbs>

      {loading && <Skeleton />}

      {!loading && (
        <>
          <section>
            <input
              type={"text"}
              placeholder={"Brand name"}
              className={"name"}
              value={name}
              onChange={(ev) => setName(ev.target.value)}
            />
          </section>

          <section>
            <h3>Logos</h3>
            <p>Upload your logo files for easy access in the design software</p>

            <ul className={"logos"}>
              <li className={"upload add-new add-new-logo"}>
                <Uploader
                  uploadType={UploadTypeEnum.Logo}
                  brandId={id ?? ""}
                  addLabel={<PlusOutlined />}
                  widgetType={ImageUploaderTypeEnum.Card}
                  onUploadSuccess={onLogoUploadSuccess}
                  hidePreview
                />
              </li>
              {logos.map((it) => (
                // <li className={`logo ${lp?.logo === it ? 'act' : ''}`} key={it} onClick={() => onLogoChange(it)}>
                <li className={`logo`} key={it.id}>
                  <img src={getImagePath(it.path || "")} alt={""} loading="lazy"/>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h3>Colors</h3>
            <p>
              Create a custom palette of brand colors to make designing more
              efficient
            </p>

            <ul className={"colors"}>
              <Dropdown
                placement={"topCenter"}
                trigger={["click"]}
                overlay={
                  // <ColorPicker color={'#000000'} onChange={c => throttledOnChange.current(c.hex)} onChangeComplete={c => throttledOnChange.current(c.hex)} colors={[]} />
                  // <ColorPicker color={'#000000'} onChange={c => addColor(c.hex)} onChangeComplete={c => addColor(c.hex)} colors={[]} />
                  <ColorPicker
                    color={"#000000"}
                    onChangeComplete={(c) => addColor(c.hex)}
                    colors={[]}
                  />
                }
              >
                <li className={"add-new add-new-color"}>
                  <PlusOutlined />
                </li>
              </Dropdown>

              {colors.map((it) => (
                // <li className={`logo ${lp?.logo === it ? 'act' : ''}`} key={it} onClick={() => onLogoChange(it)}>
                <li className={`color`} key={it.colorCode}>
                  <span style={{ backgroundColor: it.colorCode }} />
                  {/* <a href="javascript:void(0)" className="removeCustomColor" data-bind="click: function(data, event) { $parent.deleteMemberColor($data.colorCode, data, event) }">
                    <svg className="icon icon-trash"><use xlink:href="#icon-trash"></use></svg>
                  </a> */}
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h3>Brand Fonts</h3>
            <p>
              Save your favorite styles for consistent branding across all your
              marketing. You can click each slot to assign a font.
            </p>

            <div className={"fonts"}>
              <h1
                className={"set-font-header"}
                style={{
                  fontFamily: fontHeader.name,
                  fontWeight: fontHeader.bold ? "bold" : "initial",
                  fontStyle: fontHeader.italic ? "italic" : "normal",
                  textDecoration: fontHeader.underline ? "underline" : "none",
                }}
              >
                {fontHeader.name
                  ? fontHeader.name + ", " + fontHeader.size
                  : "Set Header font"}
              </h1>
              <FontSelect
                onChange={setFontHeaderCallback}
                nameDefaultValue={fontHeader.name || ""}
                sizeDefaultValue={fontHeader.size || 30}
                boldDefaultValue={fontHeader.bold || false}
                italicDefaultValue={fontHeader.italic || false}
                underlineDefaultValue={fontHeader.underline || false}
              />

              <h2
                className={"set-font-subheader"}
                style={{
                  fontFamily: fontSubheader.name,
                  fontWeight: fontSubheader.bold ? "bold" : "initial",
                  fontStyle: fontSubheader.italic ? "italic" : "normal",
                  textDecoration: fontSubheader.underline
                    ? "underline"
                    : "none",
                }}
              >
                {fontSubheader.name
                  ? fontSubheader.name + ", " + fontSubheader.size
                  : "Set Subheader font"}
              </h2>
              <FontSelect
                onChange={setFontSubheaderCallback}
                nameDefaultValue={fontSubheader.name || ""}
                sizeDefaultValue={fontSubheader.size || 20}
                boldDefaultValue={fontSubheader.bold || false}
                italicDefaultValue={fontSubheader.italic || false}
                underlineDefaultValue={fontSubheader.underline || false}
              />

              <p
                className={"set-font-body-text"}
                style={{
                  fontFamily: fontBodyText.name,
                  fontWeight: fontBodyText.bold ? "bold" : "initial",
                  fontStyle: fontBodyText.italic ? "italic" : "normal",
                  textDecoration: fontBodyText.underline ? "underline" : "none",
                }}
              >
                {fontBodyText.name
                  ? fontBodyText.name + ", " + fontBodyText.size
                  : "Set Body text font"}
              </p>
              <FontSelect
                onChange={setFontBodyTextCallback}
                nameDefaultValue={fontBodyText.name || ""}
                sizeDefaultValue={fontBodyText.size || 10}
                boldDefaultValue={fontBodyText.bold || false}
                italicDefaultValue={fontBodyText.italic || false}
                underlineDefaultValue={fontBodyText.underline || false}
              />
            </div>

            <h3>Pro Fonts</h3>
            <p>
              Find the perfect font with 1000+ options from the{" "}
              <Button type={"LinkPrimary"}>Google Font Library</Button>.
            </p>

            <ul className={"pro-fonts"}>
              {proFonts.map((it) => (
                <li
                  className={`pro-font`}
                  key={it.id}
                  style={{ fontFamily: it.name }}
                >
                  {it.name}
                  <DeleteOutlined
                    className={"remove-pro-font"}
                    onClick={() => removeProFont(it.name || "")}
                  />
                </li>
              ))}

              <li className={"add-new add-new-pro-font"}>
                <PlusOutlined />
              </li>

              <Select
                size={"large"}
                onChange={addProFont}
                key={""}
                defaultValue={""}
                className={"google-font-family-dropdown"}
                showSearch
                optionFilterProp="children"
                // filterOption={defaultSelectFilterOption} filterSort={defaultSelectFilterSort}
              >
                <Option value={""} disabled={true}>
                  Select Google Font
                </Option>
                {GoogleFonts.map((it) => (
                  <Option
                    key={it}
                    value={it}
                    className={it}
                    style={{ fontFamily: it }}
                  >
                    {it}
                  </Option>
                ))}
              </Select>
            </ul>
          </section>

          <section>
            <h3>Background Images</h3>
            <p>Upload images to use on backgrounds across all products</p>

            <ul className={"background-images"}>
              <li className={"upload add-new add-new-background-image"}>
                <Uploader
                  uploadType={UploadTypeEnum.BackgroundImage}
                  brandId={id ?? ""}
                  addLabel={<PlusOutlined />}
                  widgetType={ImageUploaderTypeEnum.Card}
                  onUploadSuccess={onBackgroundImageUploadSuccess}
                  hidePreview
                />
              </li>
              {backgroundImages.map((it) => (
                // <li className={`logo ${lp?.logo === it ? 'act' : ''}`} key={it} onClick={() => onLogoChange(it)}>
                <li className={`logo`} key={it.id}>
                  <img src={getImagePath(it.path || "")} alt={""} loading="lazy" />
                </li>
              ))}
            </ul>
          </section>

          <footer>
            <Button
              disabled={disableCreateButton()}
              loading={saving}
              onClick={save}
              type={"Primary"}
            >
              {editing ? "Update Brand" : "Create Brand"}
            </Button>
          </footer>
        </>
      )}
    </div>
  );
}
